import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';
import * as sagaOrder from './../OrderDetail/saga';

export default function*() {
    yield takeLatest(constants.UPDATE_WRONG_PROCESS_ORDER.REQUEST, saga.updateWrongProcess);
    yield takeLatest(constants.UPDATE_WRONG_PROCESS_ORDER.SUCCESS, sagaOrder.fetchLog);
}